import styled from 'styled-components';

export const StyledDirectoryWrapper = styled.div`
  min-width: 400px;
  min-height: 620px;
  display: flex;
  justify-content: flex-start;
  position: relative;
`;
